export default __webpack_public_path__ + "static/media/travis.12a5ddf5.webp";